import * as actionTypes from '../actions/actionTypes';

const initialState = {
    error: null,
    userName: null,
	password: null,
	verified: null,
	uniqueId: null,
	fullName: null,
	jurisdiction: null,
	occupation: null,
	expertise: null,
	userType: null,
	caseId: null,
    isAuthenticated: null,
    cases: [],
    telephone: null, 
    address: null,
    email: null,
    hkid: null,
    passport: null,
    companyIncorporationLocation: null,
    registeredAddress: null,
    country: null,
    postalCode: null,
    isLoading: false,
    isLoadingUpdate: false,
    typeOfAccount: null
};

const userInformationReducer = (state = initialState, action) => {
    
    
    switch (action.type) {
        
        case actionTypes.SUCCESS_USER_INFORMATION:
        // console.log('userInformationReducer reducer: action.payload.type: '+action.payload.type)
            return {
                ...state,
                userName: action.payload.userName,
                password: action.payload.password,
                verified: action.payload.verified,
                uniqueId: action.payload.uniqueId,
                typeOfAccount:action.payload.type,
                fullName: action.payload.name,
                jurisdiction: action.payload.jurisdiction,
                occupation: action.payload.occupation,
                expertise: action.payload.expertise,
                caseId: action.payload.caseId,
                isAuthenticated: action.payload.isAuthenticated,
                cases: action.payload.cases,
                telephone: action.payload.telephone,
                address: action.payload.address,
                email: action.payload.email_address,
                hkid: action.payload.hkid,
                passport: action.payload.passport,
                companyIncorporationLocation: action.payload.company_incorporation_location,
                registeredAddress: action.payload.registered_address,
                country: action.payload.country,
                postalCode: action.payload.postal_code, 
                isLoading: false,
            };
        case actionTypes.FAIL_USER_INFORMATION:
            return {
                ...state,
                error: action.error,
                isLoading: false,
            };
        case actionTypes.START_USER_INFORMATION:
        return {
            ...state,
            isLoading: true,
        };
        case actionTypes.UPDATE_USER_INFO_START:
        return {
            ...state,
            isLoadingUpdate: true,
        };
        case actionTypes.UPDATE_USER_INFO_SUCCESS:
        return {
            ...state,
            passport: action.payload.passport,
            companyIncorporationLocation: action.payload.company_incorporation_location,
            email: action.payload.email_address,
            address: action.payload.address,
            hkid: action.payload.hkid,
            isLoadingUpdate: false,
        };
        case actionTypes.UPDATE_USER_INFO_ERROR:
        return {
            ...state,
            error: action.error,
            isLoadingUpdate: false,
        };
        default:
            return state;
    }
};

export default userInformationReducer;